document.addEventListener("DOMContentLoaded", function () {
    if (!document.querySelector(".content").classList.contains("_product-page")) {
        ymaps.ready(function () {
            var myMap = new ymaps.Map(
                "map-showroom",
                {
                    center: [55.735263, 37.569173],
                    zoom: 10,
                    controls: [],
                },
                {
                    searchControlProvider: "yandex#search",
                }
            );
            myMap.controls.add("zoomControl");
            myMap.behaviors.disable("scrollZoom");
            var el = document.getElementById("map-showroom");
            var json = el.getAttribute("data-points");

            // var locations = {
            //     'Москва': [55.7558, 37.6176],
            //     'Санкт-Петербург': [59.9343, 30.3351],
            // };

            var allPoints = JSON.parse(json);
            var filteredPoints = allPoints;
            var currentBrendFilter = [];
            var currentSeriesFilter = [];

            document.querySelectorAll('.js-show-map-button').forEach(function (button) {
                button.addEventListener('click', function () {
                    var coordinates = this.getAttribute('data-item-coordinates').split(',').map(Number);
                    // Предположим, что переменная 'myMap' содержит ссылку на вашу Яндекс.Карту
                    myMap.setCenter(coordinates, 14); // Установите центр и зум по вашему желанию
                });
            });

            function addPointsToMap(points) {
                myMap.geoObjects.removeAll();
                points.forEach(function (it) {
                    var arr_html = [];
                    if (it.timeline)
                        arr_html.push(
                            "<p><b>Режим работы:</b><br/>" + it.timeline + "</p>"
                        );
                    if (it.phone)
                        arr_html.push("<p><b>Телефон:</b><br/>" + it.phone + "</p>");
                    if (it.site)
                        arr_html.push(
                            '<p><b>Сайт:</b><br/><a href="//' +
                            it.site +
                            '">' +
                            it.site +
                            "</a></p>"
                        );
                    var brendIco = getBrendIco(it.brend);
                    var mapItem = new ymaps.Placemark(
                        it.coord,
                        {
                            hasBalloon: true,
                            openBalloonOnClick: true,
                            balloonContentHeader: it.name,
                            balloonContentBody: it.addr,
                            balloonContentFooter: arr_html.join(""),
                        },
                        {
                            iconLayout: "default#image",
                            iconImageHref: brendIco,
                            iconImageSize: [120, 151],
                            iconImageOffset: [-60, -95],
                            iconContentOffset: [0, 0],
                        }
                    );
                    myMap.geoObjects.add(mapItem);
                });
            }

            function getBrendIco(brend) {
                switch (brend) {
                    case "OBI":
                        return "/local/templates/dusberg/img/marker-2.png";
                    case "Мир Красок":
                        return "/local/templates/dusberg/img/marker-3.png";
                    case "Краскиторг":
                        return "/local/templates/dusberg/img/marker-4.png";
                    case "Колорлон":
                        return "/local/templates/dusberg/img/marker-5.png";
                    case "Штайнблюме":
                        return "/local/templates/dusberg/img/marker-6.png";
                    default:
                        return "/local/templates/dusberg/img/marker.png";
                }
            }

            addPointsToMap(allPoints);

            // Фильтр по городам
            var citySelectButton = document.querySelector('.js-select-city')
            var cityToggles = document.querySelectorAll(".js-map-filter-city");
            cityToggles.forEach(function (city) {

                // city.addEventListener('click', moveToLocation);
                city.addEventListener('click', () => {
                    citySelectButton.textContent = city.getAttribute('data-city-name');

                    moveToLocation(city);
                })

            });

            function moveToLocation(item) {
                var coordinates = item.getAttribute('data-city-coords').split(',').map(Number);

                if (coordinates && coordinates.length === 2) {
                    myMap.setCenter(coordinates); // Установите центр карты на указанные координаты
                    myMap.setZoom(10); // Установите масштаб, чтобы камера охватывала нужный город
                }
            }

            var checkboxes = document.querySelectorAll(".js-map-filter-checkbox");
            checkboxes.forEach(function (checkbox) {
                checkbox.addEventListener("change", filterPoints);
            });

            function filterPoints() {
                const filterId = this.id;
                const filterGroup = this.getAttribute("data-filter");
                const filterStatus = this.checked;

                if (filterGroup === "brend") {
                    if (filterStatus === true) {
                        if (!currentBrendFilter.includes(filterId)) {
                            currentBrendFilter.push(filterId);
                        }
                    } else {
                        currentBrendFilter = currentBrendFilter.filter(
                            (id) => id !== filterId
                        );
                    }
                }

                if (filterGroup === "series") {
                    if (filterStatus === true) {
                        if (!currentSeriesFilter.includes(filterId)) {
                            currentSeriesFilter.push(filterId);
                        }
                    } else {
                        currentSeriesFilter = currentSeriesFilter.filter(
                            (id) => id !== filterId
                        );
                    }
                }

                filteredPoints = allPoints.filter((point) => {
                    const brendMatches =
                        currentBrendFilter.length === 0 ||
                        currentBrendFilter.includes(point.brend);
                    const seriesMatches =
                        currentSeriesFilter.length === 0 ||
                        (Array.isArray(point.series) &&
                            currentSeriesFilter.some((series) =>
                                point.series.includes(series)
                            ));

                    return brendMatches && seriesMatches;
                });

                addPointsToMap(filteredPoints);
            }
        });

        // Поведение кнопок фильтров
        var buttons = document.querySelectorAll(".map__filter-button");
        var options = document.querySelectorAll(".map__filter-options");

        buttons.forEach(function (button, index) {
            button.addEventListener("click", function (event) {
                event.stopPropagation(); // prevent document click event
                this.classList.toggle("map__filter-button--active");
            });
        });

        document.addEventListener("click", function (event) {
            buttons.forEach(function (button) {
                button.classList.remove("map__filter-button--active");
            });
        });

        options.forEach(function (option) {
            option.addEventListener("click", function (event) {
                event.stopPropagation(); // prevent document click event
            });
        });

        // Карта в секции "Контакты"
        ymaps.ready(function () {
            var mapContacts = new ymaps.Map(
                "map-contacts",
                {
                    center: [55.634034, 37.444629],
                    zoom: 13,
                    controls: [],
                },
                {
                    searchControlProvider: "yandex#search",
                }
            );

            var MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
                '<div style="color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
            );

            var myPlacemark = new ymaps.Placemark(
                mapContacts.getCenter(),
                {
                    hintContent: "dusberg.ru",
                    balloonContent:
                        "108811, Россия г. Москва, Киевское шоссе 22-й км (поселение Московский), домовладение 4, строение 2, блок Г, 5 этаж, оф. 506Г",
                },
                {
                    iconLayout: "default#image",
                    iconImageHref: "/local/templates/dusberg/img/marker.png",
                    iconImageSize: [120, 151],
                    iconImageOffset: [-60, -95],
                }
            );

            mapContacts.controls.add("zoomControl");
            mapContacts.behaviors.disable("scrollZoom");
            mapContacts.geoObjects.add(myPlacemark);
        });
    }

});
